<template>
<v-container fluid>
	<v-layout align-center justify-center>
		<v-flex xs12 sm8 md6>
			<v-card flat class="elevation-2 mt-4">
				<v-toolbar flat dark :class="indicator.class">
					<v-toolbar-title>{{ indicator.message }}</v-toolbar-title>
				</v-toolbar>
				<v-card-text>
					<v-form @submit.prevent="onLogin">
						<v-text-field
							prepend-icon="phone" name="phone"
							label="Логин" type="text" v-model="phone" required>
						</v-text-field>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn type="submit" :color="indicator.class">Войти</v-btn>
						</v-card-actions>
					</v-form>
				</v-card-text>
			</v-card>
		</v-flex>
	</v-layout>
</v-container>
</template>

<script>
import { SIGN } from '@/utils'
import { AuthChecker as isAuth } from '@/utils'
import store from '@/store'

export default {
	data() {
		return {
			phone: '',
			indicator: {
				class: 'primary',
				message: 'Авторизация'
			}
		}
	},
	computed: {},
	methods: {
		onLogin() {
			this.$store.dispatch('LOGIN_REQUEST', {
				phone: this.phone
			})
			.then( () => {
				store.phone = this.phone
				this.$router.push('/verify')
			})
			.catch(err => {
        if (err.message.includes('429')) {
          this.$router.push('/captcha')
        }
				throw err
			})
		},

		checkForm(value) { //TODO write checkPhone, checkPassword
			return []
		}

	},

	created() {
		if( isAuth() ) {
			this.$router.push('/')
		}
	}

}
</script>
